export default {
  parseServerError(error, self) {
    if (error == "Error: Network Error") {
      self.$bvToast.toast(
        "Não possível conectar no servidor. Por favor, verifique a sua conexão e tente novamente.",
        { title: "Erro", variant: "danger", solid: true }
      );
    } else if (error.response.status == 400) {
      if (Array.isArray(error.response.data)) {
        error.response.data.forEach((errorItem) => {
          if (errorItem.message !== "") {
            self.$bvToast.toast(errorItem.message, {
              title: "Aviso",
              variant: "warning",
              solid: true,
            });
          } else
            self.$bvToast.toast(errorItem, {
              title: "Aviso",
              variant: "warning",
              solid: true,
            });
        });
      } else {
        self.$bvToast.toast(error.response.data, {
          title: "Aviso",
          variant: "warning",
          solid: true,
        });
      }
    } else if (error.response.status == 401) {
      self.$bvToast.toast(
        "Sua sessão expirou. Você será redirecionado para o login.",
        { title: "Erro", variant: "danger", solid: true }
      );
      self.$router.push("/pages/login");
    } else if (error.response.status == 402) {
      self.$bvToast.toast(error.response.data.message, {
        title: "Erro",
        variant: "danger",
        solid: true,
      });
    } else if (
      error.response.status == 404 ||
      error.response.status == 409 ||
      error.response.status == 417 ||
      error.response.status == 424
    ) {
      self.$bvToast.toast(error.response.data.message, {
        title: "Erro",
        variant: "danger",
        solid: true,
      });
    } else {
      self.$bvToast.toast("Ocorreu um erro ao processar a operação.", {
        title: "Erro",
        variant: "danger",
        solid: true,
      });
    }
  },

  normalizaJson(json) {
    var jsonNormalizado = json;
    console.log(jsonNormalizado);

    jsonNormalizado = jsonNormalizado.replaceAll("\b", "");
    jsonNormalizado = jsonNormalizado.replaceAll("\f", "");
    jsonNormalizado = jsonNormalizado.replaceAll("\n", " ");
    jsonNormalizado = jsonNormalizado.replaceAll("\r", "");
    jsonNormalizado = jsonNormalizado.replaceAll("\t", "");

    return jsonNormalizado;
  },

  normalizaBase64(base64) {
    var base64Normalizado = base64;

    base64Normalizado = base64Normalizado.replaceAll("\\", "");
    base64Normalizado = base64Normalizado.replaceAll("\b", "");
    base64Normalizado = base64Normalizado.replaceAll("\f", "");
    base64Normalizado = base64Normalizado.replaceAll("\n", " ");
    base64Normalizado = base64Normalizado.replaceAll("\r", "");
    base64Normalizado = base64Normalizado.replaceAll("\t", "");

    return base64Normalizado;
  },

  downloadBase64ToJpeg(base64String, name, ) {
    var a = document.createElement("a");
    a.href = "data:image/jpeg;base64,"+base64String;
    a.download = name; //File name Here
    a.click(); //Downloaded file        
	},  
};
